import ImportExport from "../../entities/importExport";

/**
 * ImportExport actions
 *
 * Call order:
 *
 * IMPORTEXPORT_SAVE_QUEUE:	adds the item to the save queue
 * --> IMPORTEXPORT_SAVE:	modifies the state
 * --> IMPORTEXPORT_SAVE_SUCCESS: if all went well
 * --> IMPORTEXPORT_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail IMPORTEXPORT_SAVE_QUEUE is during the call to IMPORTEXPORT_SAVE,
 * as adding an item to the queue should never fail.
 */

export const IMPORTEXPORT_FETCH_ONE_QUEUE: any = 'IMPORTEXPORT_FETCH_ONE_QUEUE';
export const IMPORTEXPORT_FETCH_SUCCESS: any = 'IMPORTEXPORT_FETCH_SUCCESS';
export const IMPORTEXPORT_FETCH_FAILURE: any = 'IMPORTEXPORT_FETCH_FAILURE';
export const IMPORTEXPORT_FETCH_ONE_SUCCESS: any = 'IMPORTEXPORT_FETCH_ONE_SUCCESS';
export const IMPORTEXPORT_FETCH_ONE_FAILURE: any = 'IMPORTEXPORT_FETCH_ONE_FAILURE';

export const IMPORTEXPORT_SAVE: any = 'IMPORTEXPORT_SAVE';
export const IMPORTEXPORT_SAVE_QUEUE: any = 'IMPORTEXPORT_SAVE_QUEUE';
export const IMPORTEXPORT_SAVE_SUCCESS: any = 'IMPORTEXPORT_SAVE_SUCCESS';
export const IMPORTEXPORT_SAVE_FAILURE: any = 'IMPORTEXPORT_SAVE_FAILURE';

export const IMPORTEXPORT_SAVE_MANY: any = 'IMPORTEXPORT_SAVE_MANY';
export const IMPORTEXPORT_SAVE_MANY_QUEUE: any = 'IMPORTEXPORT_SAVE_MANY_QUEUE';
export const IMPORTEXPORT_SAVE_MANY_SUCCESS: any = 'IMPORTEXPORT_SAVE_MANY_SUCCESS';
export const IMPORTEXPORT_SAVE_MANY_FAILURE: any = 'IMPORTEXPORT_SAVE_MANY_FAILURE';

export const IMPORTEXPORT_REMOVE: any = 'IMPORTEXPORT_REMOVE';
export const IMPORTEXPORT_REMOVE_QUEUE: any = 'IMPORTEXPORT_REMOVE_QUEUE';
export const IMPORTEXPORT_REMOVE_SUCCESS: any = 'IMPORTEXPORT_REMOVE_SUCCESS';
export const IMPORTEXPORT_REMOVE_FAILURE: any = 'IMPORTEXPORT_REMOVE_FAILURE';

export const IMPORTEXPORT_RESTORE: any = 'IMPORTEXPORT_RESTORE';
export const IMPORTEXPORT_RESTORE_QUEUE: any = 'IMPORTEXPORT_RESTORE_QUEUE';
export const IMPORTEXPORT_RESTORE_SUCCESS: any = 'IMPORTEXPORT_RESTORE_SUCCESS';
export const IMPORTEXPORT_RESTORE_FAILURE: any = 'IMPORTEXPORT_RESTORE_FAILURE';

export const IMPORTEXPORT_RESTORE_MANY: any = 'IMPORTEXPORT_RESTORE_MANY';
export const IMPORTEXPORT_REMOVE_MANY: any = 'IMPORTEXPORT_REMOVE_MANY';

/* Fetch actions */
export const fetchImportExportSuccess = (importExports: ImportExport[], partial: boolean, lastFetch: number) => ({type: IMPORTEXPORT_FETCH_SUCCESS, importExports, partial, lastFetch});
export const fetchImportExportFailure = (err: any) => {
		console.error('ImportExportAction: fetchImportExportFailure', err);
		return {type: IMPORTEXPORT_FETCH_FAILURE, err};
};
export const fetchOneImportExportQueue = (importExportId: string) => ({type: IMPORTEXPORT_FETCH_ONE_QUEUE, importExportId});
export const fetchOneImportExportSuccess = (importExport: ImportExport) => ({type: IMPORTEXPORT_FETCH_ONE_SUCCESS, importExport});
export const fetchOneImportExportFailure = (id: string, err: any) => {
		console.error('ImportExportAction: fetchOneImportExportFailure', err);
		return {type: IMPORTEXPORT_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveImportExport = (importExport: ImportExport) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE action', importExport?.id);
    return {type: IMPORTEXPORT_SAVE, importExport};
}
export const saveImportExportQueue = (importExport: ImportExport, onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE_QUEUE action', importExport?.id);
    return {type: IMPORTEXPORT_SAVE_QUEUE, importExport, onQueued};
}
export const saveImportExportSuccess = (importExport: ImportExport) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE_SUCCESS action', importExport?.id);
    return {type: IMPORTEXPORT_SAVE_SUCCESS, importExport};
}
export const saveImportExportFailure = (importExport: ImportExport, status: number, message: string) => {
    console.warn(`⮂ IMPORTEXPORT_SAVE_FAILURE error saving importExport: HTTP ${status}: ${message}`, importExport?.id);
    return {type: IMPORTEXPORT_SAVE_FAILURE, importExport, status, message};
};

/* SaveMany actions */
export const saveManyImportExports = (importExports: ImportExport[]) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE_MANY action', importExports?.map(importExport => importExport?.id).join(','));
    return {type: IMPORTEXPORT_SAVE_MANY, importExports};
}
export const saveManyImportExportsQueue = (importExports: ImportExport[], onQueued?: (saved: boolean) => void) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE_MANY_QUEUE action', importExports?.map(importExport => importExport.id).join(','));
    return {type: IMPORTEXPORT_SAVE_MANY_QUEUE, importExports, onQueued};
}

export const saveManyImportExportsSuccess = (importExports: ImportExport[]) => {
    // console.debug('⮂ IMPORTEXPORT_SAVE_MANY_SUCCESS action', importExports?.map(importExport => importExport.id).join(','));
    return {type: IMPORTEXPORT_SAVE_MANY_SUCCESS, importExports};
}
export const saveManyImportExportsFailure = (importExports: ImportExport[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_IMPORTEXPORTS_FAILURE Error saving importExports: HTTP ${status}: ${message}`, importExports?.map(importExport => importExport.id).join(','));
		return {type: IMPORTEXPORT_SAVE_MANY_FAILURE, importExports, status, message};
};

/* Remove actions */
export const removeImportExport = (importExport: ImportExport) => ({ type: IMPORTEXPORT_REMOVE, importExport });
export const removeImportExportQueue = (importExport: ImportExport) => ({ type: IMPORTEXPORT_REMOVE_QUEUE, importExport });
export const removeImportExportSuccess = (importExport: ImportExport) => ({ type: IMPORTEXPORT_REMOVE_SUCCESS, importExport });
export const removeImportExportFailure = (importExport: ImportExport, status: number, message: string) => {
	console.error(`Redux: removeImportExportFailure Error removing importExport: HTTP ${status}: ${message}`);
	return ({ type: IMPORTEXPORT_REMOVE_FAILURE, importExport, status, message });
};

/* Restore actions */
export const restoreImportExport = (importExport: ImportExport) => ({ type: IMPORTEXPORT_RESTORE, importExport });
export const restoreImportExportQueue = (importExport: ImportExport) => ({ type: IMPORTEXPORT_RESTORE_QUEUE, importExport });
export const restoreImportExportSuccess = (importExport: ImportExport) => ({ type: IMPORTEXPORT_RESTORE_SUCCESS, importExport });
export const restoreImportExportFailure = (importExport: ImportExport, status: number, message: string) => {
	console.error(`Redux: restoreImportExportFailure Error restoring importExport: HTTP ${status}: ${message}`);
	return ({ type: IMPORTEXPORT_RESTORE_FAILURE, importExport, status, message });
};

/* RestoreMany actions */
export const restoreManyImportExports = (importExports: ImportExport[]) => ({ type: IMPORTEXPORT_RESTORE_MANY, importExports });

/* RemoveMany actions */
export const removeManyImportExports = (importExports: ImportExport[]) => ({ type: IMPORTEXPORT_REMOVE_MANY, importExports });